import { sendEvent } from '../analytics-web-client-wrapper';
import { processEventPayload } from './process-event-payload';
export var handleEvent = function handleEvent(event, tags, logger, client) {
  if (!event.payload) {
    return;
  }
  var payload = processEventPayload(event, tags);
  sendEvent(logger, client)(payload);
};